import { makeStyles } from "tss-react/mui";
import { COL_WIDTH_NHC } from "@miplatform/constants";
import { Box } from "@mui/material";

export function ColumnHeader({ children, onClick }) {
  const { classes } = useStyles();

  return (
    <Box
      className={classes.container}
      data-testid="column-header"
      onClick={onClick}
    >
      {children}
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  container: {
    flex: 1,
    backgroundColor: theme.palette.blue.light,
    borderRadius: "8px 8px 0 0",
    minWidth: COL_WIDTH_NHC,
    cursor: "pointer",
  },
}));
